import { func, object, type, optional, boolean } from 'superstruct';

export const liveChatConfigSchema = object({
  liveChatClient: type({
    handleUserChatEvents: func(),
    subscribeToAgentChatEvents: func(),
  }),
  aiAgentAssistBotLiveChatClient: optional(
    type({
      handleUserChatEvents: func(),
      subscribeToAgentChatEvents: func(),
      subscribeToHandoffEvents: func(),
    }),
  ),
  shouldShowNavigateAway: optional(boolean()),
});
